import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { getAllCrosswalks, getAllFrameworks } from './api'

export const allFrameworksAtom = atomWithRefresh(async () => {
  return getAllFrameworks()
})

export const allCrosswalksAtom = atomWithRefresh(async () => {
  return getAllCrosswalks()
})
